<script setup>
import { computed, ref } from 'vue';

import { useProjectStore } from '@/stores/project';

import AppCreditsHistoryDrawer from '@/components/billing/credits/CreditsHistoryDrawer.vue';

defineOptions({
  inheritAttrs: false,
});

const projectStore = useProjectStore();

const selectedProject = computed(() => {
  return projectStore.currentProject?.project ?? null;
});

const creditValue = computed(() => {
  if (!selectedProject.value?.credit_balance) return '0 credits';
  if (selectedProject.value.credit_balance === 1) return '1 credit';
  return `${selectedProject.value?.credit_balance} credits`;
});

const showCreditHistory = ref(false);
const openDrawer = ref(false);
</script>
<template>
  <Tag
    v-if="creditValue"
    v-bind="$attrs"
    severity="primary"
    :value="creditValue"
    class="cursor-pointer hover:outline"
    @click="
      showCreditHistory = true;
      openDrawer = true;
    "
  >
    {{ creditValue }}
  </Tag>
  <AppCreditsHistoryDrawer
    v-if="showCreditHistory"
    v-model:visible="openDrawer"
    :projectId="selectedProject?.id"
  />
</template>
